export class SubMenuPath {
  label: string;
  clickCb: () => void;
  goBackCb: () => void;

  constructor(label: string, clickCb: () => void, goBackCb: () => void) {
    this.label = label;
    this.clickCb = clickCb;
    this.goBackCb = goBackCb;
  }
}
